export const BUTTON_TITLE = 'Edit';
